import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "@/style/style.scss";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/style/iconfont.scss";

Vue.config.devtools = true;
Vue.config.productionTip = false;
Vue.use(ElementUI);

Vue.directive("permission", {
  inserted(el, binding) {
    const userPermissions = JSON.parse(
      sessionStorage.getItem("permission_codes")
    );
    const needPermission = binding.value;
    if (!userPermissions.includes(needPermission)) {
      el.style.display = "none";
    }
  },
});

new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
